<template>
    <div>
        <loading-custom :loading="loading" />

        <stock-manage-component
            :productId="productId"
            :product="manageStock"
            :shop="shop"
            @onUpdate="onStore($event)"
        ></stock-manage-component>
        <div class="table-responsive">
            <table class="table table-hover mb-0 c_list">
                <thead>
                    <tr>
                        <th class="">ลำดับ</th>
                        <th class="tw-w-3/12">ชื่อรายการสินค้า</th>
                        <th class="text-right">
                            จองแล้ว
                        </th>
                        <th class="text-right">
                            พร้อมส่ง
                        </th>
                        <th class="text-right">พร้อมขาย</th>
                        <th class="text-right">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="
                            tableData.data
                                ? tableData.data.length === 0
                                : tableData.data
                        "
                    >
                        <td class="text-center" colspan="5">
                            ไม่พบข้อมูล
                        </td>
                    </tr>
                    <tr v-for="(item, index) in tableData.data" :key="index">
                        <td>
                            {{ index + 1 }}
                        </td>
                        <td>
                            <div class="tw-flex tw-items-center">
                                <img
                                    class="table-image tw-mr-5"
                                    :src="item.image_url"
                                    alt=""
                                />
                                <div>
                                    {{ item.name }}
                                </div>
                            </div>
                        </td>
                        <td class="text-right">
                            <div>
                                {{item.order_product_pending[0] ? item.order_product_pending[0].sum_quantity : 0}}
                            </div>
                        </td>
                        <td class="text-right">
                            <div>
                                {{item.order_product_approve[0] ? item.order_product_approve[0].sum_quantity : 0}}
                            </div>
                        </td>
                        <td class="text-right">
                            <div>
                                {{ item.stock_balance }}
                            </div>
                        </td>
                        <td class="text-right">
                            <button
                                type="button"
                                data-type="confirm"
                                class="btn btn-sm btn-warning"
                                data-toggle="modal"
                                data-target="#manageStock"
                            >
                                <i
                                    @click="updateStock(item)"
                                    class="fa fa-edit"
                                >
                                </i>
                            </button>
                            <a :href="`/backend/s/${shop}/stocks/${item.id}`">
                                <button
                                    type="button"
                                    data-type="confirm"
                                    class="btn btn-sm btn-primary"
                                >
                                    <i class="fa fa-list"></i>
                                </button>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tw-flex tw-mt-5  tw-justify-center lg:tw-justify-end">
            <paginate
                :data="tableData"
                :page="page"
                @onPage="onPage($event)"
                v-show="tableData.total > 0"
            ></paginate>
        </div>
    </div>
</template>
<script type="application/javascript">
import paginate from "../../helper/Paginate.vue";
export default {
    props: ["shop"],
    components: {
        paginate
    },
    data() {
        return {
            page: 1,
            loading: false,
            tableData: [],
            productId: "",
            manageStock: {}
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        onStore(val) {
            if (val == "success") {
                this.getData();
            }
        },
        onPage(page) {
            this.page = page;
            this.getData();
        },
        updateStock(item) {
            this.productId = item.id;
            this.manageStock = item;
        },
        async getData() {
            // this.loading = false;
            await axios
                .get(`/ajax/s/${this.shop}/products?page=${this.page}`)
                .then(res => {
                    this.tableData = res.data.product;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.table-image {
    width: 60px;
    // max-width: 200px;
}
.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>
